import { Link } from "react-router-dom";
import { StaggerItem } from "../common/Reveal";

export default function BlogCard({ post }) {
  return (
    <StaggerItem>
      <Link
        to={`/insights/${post.slug}`}
        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-800/40 transition-colors duration-500 hover:border-sky-400/40"
        data-testid={`blog-card-${post.slug}`}
      >
        <div className="relative h-48 overflow-hidden">
          <img
            src={post.image}
            alt={post.title}
            loading="lazy"
            className="h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 rounded-full bg-ink-900/80 px-3 py-1 text-[11px] font-medium uppercase tracking-wide text-sky-400 backdrop-blur">
            {post.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-6">
          <div className="flex items-center gap-3 text-xs text-slate-500">
            <span>{post.date}</span>
            <span className="h-1 w-1 rounded-full bg-slate-600" />
            <span>{post.readTime}</span>
          </div>
          <h3 className="mt-3 font-heading text-lg font-bold leading-snug tracking-tight text-white transition-colors group-hover:text-sky-300">
            {post.title}
          </h3>
          <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{post.excerpt}</p>
          <div className="mt-5 text-sm font-medium text-sky-400">Read Article →</div>
        </div>
      </Link>
    </StaggerItem>
  );
}
